var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParcelCenterSearch = function SvgParcelCenterSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a_pf",
    d: "M16.075 14.53h-.81l-.288-.278a6.662 6.662 0 0 0 1.518-5.475c-.482-2.85-2.862-5.126-5.735-5.475a6.671 6.671 0 0 0-7.458 7.454c.349 2.87 2.626 5.25 5.478 5.731a6.672 6.672 0 0 0 5.479-1.517l.277.287v.81l4.36 4.358c.42.42 1.108.42 1.529 0 .42-.42.42-1.108 0-1.528l-4.35-4.368zm-6.156 0a4.61 4.61 0 0 1-4.617-4.615A4.61 4.61 0 0 1 9.92 5.301a4.61 4.61 0 0 1 4.617 4.614 4.61 4.61 0 0 1-4.617 4.614z"
  })));
};
export default SvgParcelCenterSearch;